import { Box, Container, Typography } from "@mui/material";
import useList from "./useList";
import CompanyStamp from "@/templates/CompanyStamp";

export const List = () => {
  const {
    list,
    isLoading,
    page,
    count,
    subscriptionProductList,
    templateList,
  } = useList();

  return (
    <Container maxWidth={"xl"}>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        gap={2}
        alignItems={"end"}
        mb={2}
      >
        <Typography
          component={"h1"}
          variant="h5"
          fontWeight={"bold"}
          gutterBottom
        >
          도장 목록
        </Typography>
      </Box>
      <CompanyStamp.List
        page={page}
        count={count}
        list={list}
        isLoading={isLoading}
        subscriptionProductList={subscriptionProductList}
        templateList={templateList}
      />
    </Container>
  );
};
